import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=ca8b52bc&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=js&"
export * from "./Icons.vue?vue&type=script&lang=js&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=ca8b52bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b52bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca8b52bc')) {
      api.createRecord('ca8b52bc', component.options)
    } else {
      api.reload('ca8b52bc', component.options)
    }
    module.hot.accept("./Icons.vue?vue&type=template&id=ca8b52bc&scoped=true&", function () {
      api.rerender('ca8b52bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/icon/Icons.vue"
export default component.exports